<template>
  <div class="commonDialogBody">
     <BillManagerOneDialog @AllData="getMsgFormSon"  ref="BillManagerOneDialog" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.mangroupName" >
    <el-select  clearable v-model="value" placeholder="请选择" @change="ChargeBillManTree">
    <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.value">
    </el-option>
  </el-select>
</el-form-item>
 <el-form-item :label="formLabelAlign.obj.userName" >
     <el-select  clearable v-model="valueone" multiple placeholder="请选择" @change="optionsoneChange">
    <el-option
      v-for="item in optionsone"
      :key="item.value"
      :label="item.userName"
      :value="item.userId">
    </el-option>
  </el-select>
          <el-button @click="handleChange" style="margin-top:-50px">配置</el-button>
    </el-form-item>
   <el-form-item :label="formLabelAlign.obj.putIn" >
    <el-select  clearable v-model="putInval" placeholder="请选择"  size="small" @change="ChargeputIn" >
        <el-option v-for="item in putIn" :key="item.putInval" :label="item.putInlab" :value="item.putInval"></el-option>
    </el-select>
  </el-form-item>
   <el-form-item :label="formLabelAlign.obj.takeOut" >
    <el-select  clearable v-model="takeOutval" placeholder="请选择"  size="small" @change="ChargetakeOut" >
        <el-option v-for="item in takeOut" :key="item.takeOutval" :label="item.takeOutlab" :value="item.takeOutval"></el-option>
    </el-select>
  </el-form-item>
   <el-form-item :label="formLabelAlign.obj.cancelAfter" >
    <el-select  clearable v-model="cancelAfterval" placeholder="请选择"  size="small" @change="ChargecancelAfter" >
        <el-option v-for="item in cancelAfter" :key="item.cancelAfterval" :label="item.cancelAfterlab" :value="item.cancelAfterval"></el-option>
    </el-select>
  </el-form-item>
   <el-form-item :label="formLabelAlign.obj.certification" >
    <el-select  clearable v-model="certificationval" placeholder="请选择"  size="small" @change="Chargecertification" >
        <el-option v-for="item in certification" :key="item.certificationval" :label="item.certificationlab" :value="item.certificationval"></el-option>
    </el-select>
  </el-form-item>  
   <el-form-item :label="formLabelAlign.obj.remarks" >
       <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BillManagerOneDialog from "../common/BillManagerOneDialog.vue";
export default {
 components: {BillManagerOneDialog},
  name: "BillManagerDialog",
  //  props:['formLabelAlign'],
  data() {
    return {
    options:[],
    value:"",
    optionsone: [],
    valueone: '',
    dialogVisible: false,
    title:"标题",
    labelPosition:'right',
    formLabelAlign:{},
    type:"",
    mangroupId:"",
     defaultProps: { children: 'children', label: 'officeName' },
    putIn:[{
        putInval:"0",
        putInlab:"否",
    },
    {
        putInval:"1",
        putInlab:"是",
    }],
    putInval:"",

    takeOut:[{
        takeOutval:"0",
        takeOutlab:"否",
    },
    {
        takeOutval:"1",
        takeOutlab:"是",
    }],
    takeOutval:"",

    cancelAfter:[{
        cancelAfterval:"0",
        cancelAfterlab:"否",
    },
    {
        cancelAfterval:"1",
        cancelAfterlab:"是",
    }],
    cancelAfterval:"",

    certification:[{
        certificationval:"0",
        certificationlab:"否",
    },
    {
        certificationval:"1",
        certificationlab:"是",
    }],
    certificationval:"",
    uservalue:"",
    userArr:[],
    userIdArr:[],
    userNameArr:[],
    office:{},
    companyId:"",
    companyName:"",
    officeId:"",
    officeName:"",
    };
  },
  methods: {
    ChargeBillManTree(){
        for(let val of this.options){
          if(val.value == this.value){
            this.mangroupId = val.Pid
            this.mangroupName = val.label
          }
        }
    },
    handleChange(){
      this.$refs.BillManagerOneDialog.titl = "配置";
      this.$refs.BillManagerOneDialog.dialogVisi = true;
    },
    optionsoneChange(){
               var value1 = this.valueone
            var id = []
          for(let i = 0; i<value1.length;i++){
            id.push(value1[i])
          }
let options = this.optionsone
        var arr = []
        options.forEach(v => {
            id.forEach(e => {
                if(v.userId == e){
                    arr.push(v);
                }
            });
        });
//         console.log(arr,arr.length);
  this.userArr = arr
if(arr.length == 0){
  this.valueone = []
}
let userIdArr = []
let userNameArr = []
for(let val of this.userArr){
  // console.log(val)
  userIdArr.push(val.userId)
  userNameArr.push(val.userName)
  this.companyId = val.companyId
  this.companyName = val.companyName
  this.officeId = val.officeId
  this.officeName = val.officeName
}
this.userIdArr = userIdArr
this.userNameArr = userNameArr


    },
    ChargeputIn(){
        // console.log(this.putInval)
    },
    ChargetakeOut(){

        // console.log(this.takeOutval)
    },
    ChargecancelAfter(){
        // console.log(this.cancelAfterval)
    },
    Chargecertification(){
        // console.log(this.certificationval)
    },
    modification(){
        if(this.title == "修改"){
     let obj = {
              "id":this.formLabelAlign.id,
              "mangroupId":this.mangroupId,// 票据管理组ID
              "mangroupName":this.mangroupName,
              "userNames":this.userNameArr,
              "userIds":this.userIdArr,
              "companyId":this.companyId,
              "companyName":this.companyName,
              "officeId":this.officeId,
              "officeName":this.officeName,
              "putIn":this.putInval,
              "takeOut":this.takeOutval,
              "cancelAfter":this.cancelAfterval,
              "certification":this.certificationval,
                }
          // console.log(obj)
          if(obj.userIds == undefined || obj.userIds.length ==0){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          console.log(1)
          }else if(obj.putIn == undefined || obj.putIn == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
           console.log(1)
          }else if(obj.takeOut == undefined || obj.takeOut == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
           console.log(1)
          }else if(obj.cancelAfter == undefined || obj.cancelAfter == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
           console.log(1)
          }else if(obj.certification == undefined || obj.certification == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
           console.log(1)
          }else if(obj.mangroupId == undefined || obj.mangroupId == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
           console.log(1)
          }else{
        this.$http.post(this.$requestUrl.POST_BILL_MANAGERADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                 this.$emit("Visible",false)
                          this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }else if(this.title == "添加"){
               let obj = {
              "mangroupId":this.mangroupId,// 票据管理组ID
              "mangroupName":this.mangroupName,
              "userNames":this.userNameArr,
              "userIds":this.userIdArr,
              "companyId":this.companyId,
              "companyName":this.companyName,
              "officeId":this.officeId,
              "officeName":this.officeName,
              "putIn":this.putInval,
              "takeOut":this.takeOutval,
              "cancelAfter":this.cancelAfterval,
              "certification":this.certificationval,
                }
          // console.log(obj)
          if(obj.userIds == undefined || obj.userIds.length ==0){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.putIn == undefined || obj.putIn == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.takeOut == undefined || obj.takeOut == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.cancelAfter == undefined || obj.cancelAfter == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.certification == undefined || obj.certification == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.mangroupId == undefined || obj.mangroupId == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILL_MANAGERADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                this.$emit("Visible",false)
                this.$message({
                    type: 'success',
                    message: '添加成功!'
                });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }


    },
    getMsgFormSon(data){
        this.office = data
        let obj = {
          "officeId":data.officeId,
        }
         this.$http.post(this.$requestUrl.POST_STAFF,obj).then((res) => {
        let data = res.data.data;
          this.optionsone = data
          for (let i = 0 ;i<data.length;i++){
            if(data[i].userId != this.userArr[0]){
              this.valueone = []
            }
          }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    userList(){
         let obj = {
         "treeGroup":1,
          "officeType":"1",
          "grade":"1"
       }
      this.$http.post(this.$requestUrl.GET_USER_OFFICE_TREE,obj).then((res) => {
        let data = res.data.data;
          this.osData = data
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    handleClose(done) {
      this.dialogVisible = false
    },
  },
      mounted() {
          this.userList();
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
        // this.userList();
        if(this.formLabelAlign.obj == undefined){
          let obj = {
            "mangroupName":"票据管理组",
            "userName":"票据管理人名称",
            "putIn":"入库权限",
            "takeOut":"领用权限",
            "cancelAfter":"核销权限",
            "certification":"凭证审核",
            "remarks":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>